import { Body } from "app/_components/components/Text/Body";
import { Heading } from "app/_components/components/Text/Heading";
import { Button } from "app/_components/components/Button";
import Link from "next/link";

interface PriceCardProps {
  buttonBgColor?: string;
  title: string;
  description: string;
  CTALabel: string;
  bgStyles?: React.CSSProperties;
  href: string;
}

function PriceCard({
  title,
  description,
  CTALabel,
  href,
  buttonBgColor = "#FFFFFF",
  bgStyles = {}
}: PriceCardProps) {
  return (
    <div
      className="relative mb-[48px] hidden items-center gap-4 overflow-hidden rounded-2xl p-[40px] [@media(min-width:710px)]:flex"
      style={{ ...bgStyles }}
    >
      <div className="basis-1/3 flex-col self-start text-white">
        <Body size="sm" className="leading-[20px] font-semibold">
          {title}
        </Body>
        <Heading
          size="md"
          className="mt-[8px] leading-[32px] font-medium tracking-[-0.5px]"
        >
          {description}
        </Heading>
        <div className="mt-[16px] flex">
          <Link href={href} target="_blank" rel="noopener noreferrer">
            <Button
              size="sm"
              className="font-semibold"
              style={{ backgroundColor: buttonBgColor }}
            >
              {CTALabel}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PriceCard;
